var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(_vm.blockComponent,{tag:"component",attrs:{"block-data":_vm.block,"project":_vm.project}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h3',[_vm._v("Einstellung zum Onlinestatus")]),_vm._v(" "),_c('GeneralBlock',{attrs:{"block-data":_vm.block}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14224bdd","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/admin/block/Edit.vue
// module id = null
// module chunks = 